"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMyTokenIds = exports.requestTokenApproval = void 0;
const request_formatters_1 = require("../request-formatters");
const response_formatters_1 = require("../response-formatters");
exports.requestTokenApproval = {
    request: (params, marketplaceId) => {
        const collection = (0, request_formatters_1.getPrincipal)(marketplaceId);
        return [collection, BigInt(params.tokenId)];
    },
    response: (response) => {
        return (0, response_formatters_1.getResultStatus)(response);
    }
};
exports.getMyTokenIds = {
    response: (response) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => data.map((tokenId) => tokenId.toString()));
    }
};
